import { render, staticRenderFns } from "./AccionesEstudiante.vue?vue&type=template&id=3584ec18&scoped=true&"
import script from "./AccionesEstudiante.vue?vue&type=script&lang=js&"
export * from "./AccionesEstudiante.vue?vue&type=script&lang=js&"
import style0 from "./AccionesEstudiante.vue?vue&type=style&index=0&id=3584ec18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3584ec18",
  null
  
)

export default component.exports